import { useMemo } from 'react'

import { ReceiversView } from '@apps-common/apps/portal/pages/receivers/components'

import { UnauthorizedCard } from '@apps-common/components/common'
import { usePortalFirebaseUser } from '@apps-common/hooks/usePortalFirebaseUser'
import { IonPage } from '@ionic/react'

export const ReceiversPage = () => {
  const fbUser = usePortalFirebaseUser()

  const authorized = useMemo(() => fbUser?.isMonitoringCentre || fbUser?.isRadionetUser, [fbUser])

  return (
    <IonPage>
      {!authorized && <UnauthorizedCard />}
      {authorized && <ReceiversView />}
    </IonPage>
  )
}
